import SubLabel from "components/Atoms/Sublabel";
import React from "react";
import { LabelList, ValidatedLabelList } from "../LabelList";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import { MultiModalPickerProps } from "../props";
import MultiBookkeepingList from "./MultiBookkeepingList";


const BookkeepingListItem = bookkeeping => <>
  <div>
    <div>{bookkeeping.name}</div>
    <SubLabel small>{bookkeeping.code}</SubLabel>
  </div>
</>

interface BookkeepingMultiModalPickerProps extends MultiModalPickerProps<server.dto.BookkeepingSmall> {
  bookkeepingSecurityScope: server.dto.BookkeepingSecurityScopes;
}

export const BookkeepingMultiModalPicker = (props: BookkeepingMultiModalPickerProps) => {
  const { ...rest } = props;

  return <>
    <MultiModalPickerWithChooseButton<server.dto.BookkeepingSmall>
      onNewClicked={() => { }}
      renderLabelContent={BookkeepingListItem}
      getId={(b) => b.bookkeepingId}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Bookkeeping.resxBookkeeping}
      modalSize="small"
      renderModalContent={(editedValue, setEditedValue) => <MultiBookkeepingList
        excludeKeys={editedValue.map(b => b.bookkeepingId)}
        onChange={setEditedValue}
        value={editedValue}
        bookkeepingSecurityScope={props.bookkeepingSecurityScope}
      />}
      {...rest}
    />
  </>;
};

export const SelectedBookkeepings = (props: { value: server.dto.BookkeepingSmall[] }) => {
  return <LabelList
    value={props.value}
    renderLabelContent={BookkeepingListItem}
    getId={(b) => b.bookkeepingId}
  />;
}

interface ValidatedSelectedBookkeepingsProps {
  value: server.dto.BookkeepingSmall[];
  validatorKey: string;
}

export const ValidatedSelectedBookkeepings = (props: ValidatedSelectedBookkeepingsProps) => {
  return <ValidatedLabelList
    value={props.value}
    validatorKey={props.validatorKey}
    renderLabelContent={BookkeepingListItem}
    getId={(b) => b.bookkeepingId}
  />
}